import { c as _c } from "react/compiler-runtime";
import { Checkbox, Radio, RadioGroup, Text } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
import { Box } from "@mui-wrapper";
import { feedbackControlWrapperSx, feedbackOptionRowSx } from "@components/analytics/in-house/feedback/analytics-feedback-helper";
/** Renders a vertical list of selectable option rows for a survey step. */
export function AnalyticsFeedbackOptionList(t0) {
  const $ = _c(18);
  const {
    options,
    selectedValues,
    isMultiSelect,
    onToggle
  } = t0;
  const selectedValue = selectedValues[0] ?? "";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMultiSelect || $[2] !== onToggle || $[3] !== options || $[4] !== selectedValues) {
    let t3;
    if ($[6] !== isMultiSelect || $[7] !== onToggle || $[8] !== selectedValues) {
      t3 = option => {
        const isSelected = selectedValues.includes(option.value);
        return <Box key={option.value} role="button" onClick={() => onToggle(option.value)} sx={{
          ...feedbackOptionRowSx,
          borderColor: isSelected ? PALETTE_VARS.Chip.primary.outline : "divider",
          backgroundColor: isSelected ? PALETTE_VARS.Chip.primary.background : "transparent"
        }}><Box sx={feedbackControlWrapperSx}>{isMultiSelect ? <Checkbox checked={isSelected} readOnly={true} /> : <Radio value={option.value} checked={isSelected} />}</Box><Text variant="bodyM">{option.label}</Text></Box>;
      };
      $[6] = isMultiSelect;
      $[7] = onToggle;
      $[8] = selectedValues;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = options.map(t3);
    $[1] = isMultiSelect;
    $[2] = onToggle;
    $[3] = options;
    $[4] = selectedValues;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <Box sx={t1}>{t2}</Box>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const rows = t3;
  if (isMultiSelect) {
    return rows;
  }
  let t4;
  if ($[12] !== onToggle) {
    t4 = (_, value) => onToggle(value);
    $[12] = onToggle;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== rows || $[15] !== selectedValue || $[16] !== t4) {
    t5 = <RadioGroup value={selectedValue} onChange={t4}>{rows}</RadioGroup>;
    $[14] = rows;
    $[15] = selectedValue;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}